import { render, staticRenderFns } from "./CoordsEditor.vue?vue&type=template&id=78d15fd8&scoped=true&"
import script from "./CoordsEditor.vue?vue&type=script&lang=js&"
export * from "./CoordsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d15fd8",
  null
  
)

export default component.exports